const resolveProductFromGlobals = article => {
  // Ветка сейчас дремлющая: продюсера window.productItem (singular) в проекте
  // нет. Guard по коду не даёт при возврате singular-глобала подложить чужой
  // товар — отдаём его только когда productCode совпадает с запрошенным
  // артикулом, иначе проваливаемся к productItems[article].
  if (
    typeof productItem !== 'undefined' &&
    productItem &&
    String(productItem.productCode) === String(article)
  ) {
    return productItem
  }

  if (
    typeof productItems !== 'undefined' &&
    productItems &&
    typeof productItems[article] !== 'undefined'
  ) {
    return productItems[article]
  }

  return {}
}

export { resolveProductFromGlobals }
export default resolveProductFromGlobals
